<template>
  <div class="Exportjre">
    <v-row>
      <v-col class="text-right">
        <!-- <v-btn type="button" @click="exportexceljre(tokenexport, exportthn,exportbln,exportps,paparnegeriexport)" color="blue white white--text">
            <span class="material-icons">file_download</span>
            {{ $t("muatturun") }} {{ $t("jre") }}
          </v-btn> -->
           <download-excel
              :data = "papardatajre"
              type="csv"
              name="jre.xls"
              >
              <v-btn type="button" color="blue white white--text">
                <span class="material-icons">file_download</span>
                {{ $t("muatturun") }} {{ $t("jre") }}
              </v-btn>
            </download-excel>
      </v-col>
    </v-row>
    &nbsp;
    <v-row>
      <v-col cols="12" sm="12">
        <v-data-table
          :headers="headers"
          :items="papardatajre"
          :items-per-page="10"
          class="elevation-1"
          height="500"
          fixed-header
        >
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import i18n from "@/i18n";
// import hidServices from "@/services/lookupField";
// const lookup = new hidServices();
import axios from "../../plugins/axios";
import Vue from 'vue';
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
  Name: "Exportjre",
  setup() {},
  props: ["papardatajre", "exportthn", "exportbln", "exportps", "paparnegeriexport"],
  mounted() {},
  data: () => ({
    tokenexport: window.localStorage.getItem('tokenexport'),
    databatch: "",
    headers: [
      { text: "HID", value: "HID"},
      { text: "BNO", value: "BNO"},
      { text: "Pusingan", value: "Pusingan"},
      { text: "S", value: "S"},
      { text: "NG", value: "NG"},
      { text: "DP", value: "DP"},
      { text: "DB", value: "DB"},
      { text: "BP", value: "BP"},
      { text: "ST", value: "ST"},
      { text: "NOTK", value: "NOTK"},
      { text: "NOIR", value: "NOIR"},

      { text: "SRAj", value: "SRAj"},
      { text: "SRAm", value: "SRAm"},
      { text: "SRSj", value: "SRSj"},
      { text: "SRSm", value: "SRSm"},
      { text: "SMAj", value: "SMAj"},
      { text: "SMAm", value: "SMAm"},
      { text: "SMSj", value: "SMSj"},
      { text: "SMSm", value: "SMSm"},
      { text: "TAWj", value: "TAW"},
      { text: "TAWm", value: "TAWm"},
      { text: "TASj", value: "TAS"},
      { text: "TASm", value: "TASm"},

      { text: "KKKj", value: "KKK"},
      { text: "KKKm", value: "KKKm"},
      { text: "KKSj", value: "KKS"},
      { text: "KKSm", value: "KKSm"},
      { text: "PKK", value: "PKK"},
      { text: "PKS", value: "PKS"},
      { text: "JPK(i)", value: "JPK1"},
      { text: "JPK(ii)", value: "JPK2"},
      { text: "JPK(iii)", value: "JPK3"},
      { text: "KP", value: "KP"},
      { text: "JKK", value: "JKK"},
      { text: "JKS", value: "JKS"},

      //PENAMBAHAN BARU 2024
      { text: "KPKK", value: "KPKK"},
      { text: "KPKKRM", value: "KPKKRM"},
      { text: "KPKS", value: "KPKS"},
      { text: "KPKSRM", value: "KPKSRM"},
      { text: "PPKK", value: "PPKK"},
      { text: "PPKS", value: "PPKS"},

      { text: "JR", value: "JR"},
      { text: "JMR", value: "JMR"},
      { text: "PL", value: "PL"},
      { text: "HR", value: "HR"},
      { text: "PR", value: "PR"},
      { text: "BT", value: "BT"},
      { text: "KR", value: "KR"},
      { text: "BDR", value: "BDR"},
      { text: "BDRLain", value: "BDRLain"},
      { text: "JT", value: "JT"},
      { text: "JTLain", value: "JTLain"},
      { text: "BA", value: "BA"},
      { text: "BALain", value: "BALain"},
      { text: "AM", value: "AM"},
      { text: "AM2", value: "AM2"},
      { text: "AMLain", value: "AMLain"},

      { text: "BE", value: "BE"},
      { text: "ITT", value: "ITT"},
      { text: "ITM", value: "ITM"},
      { text: "ITK", value: "ITK"},
      { text: "SP1", value: "SP1"},
      { text: "SP2", value: "SP2"},
      { text: "SP3", value: "SP3"},
      { text: "SPLain", value: "SPLain"},
      { text: "KS", value: "KS"},
      { text: "TKS", value: "TKS"},
      { text: "SKS1", value: "SKS1"},
      { text: "SKS2", value: "SKS2"},
      { text: "SKSLain", value: "SKSLain"},
      
      { text: "KP1", value: "KP1"},
      { text: "KP2", value: "KP2"},
      { text: "KP3", value: "KP3"},
      { text: "KP4", value: "KP4"},
      { text: "KP5", value: "KP5"},
      { text: "KP6", value: "KP6"},
      { text: "KP7", value: "KP7"},
      { text: "KP8", value: "KP8"},
      { text: "KP9", value: "KP9"},
      { text: "KP10", value: "KP10"},
      { text: "KP11", value: "KP11"},
      { text: "PR1", value: "PR1"},
      { text: "PR1i", value: "PR1_i"},
      { text: "PR2", value: "PR2"},
      { text: "PR3", value: "PR3"},
      { text: "PR4", value: "PR4"},
      { text: "PR5", value: "PR5"},
      { text: "PR6", value: "PR6"},
      { text: "PR7", value: "PR7"},
      { text: "PR8", value: "PR8"},
      { text: "PR9", value: "PR9"},
      { text: "PR10", value: "PR10"},
      { text: "PR11", value: "PR11"},
      { text: "PR12", value: "PR12"},
      { text: "PR13", value: "PR13"},
      { text: "PR14", value: "PR14"},
      { text: "PR15", value: "PR15"},
      { text: "PR16", value: "PR16"},
      { text: "PR17", value: "PR17"},
      { text: "PR18", value: "PR18"},
      { text: "PR19", value: "PR19"},
      { text: "PR20", value: "PR20"},
      { text: "PR21", value: "PR21"},
      { text: "PR22", value: "PR22"},
      { text: "PR23", value: "PR23"},
      { text: "PR24", value: "PR24"},
      { text: "PR25", value: "PR25"},
      { text: "PR26", value: "PR26"},
      { text: "PR27", value: "PR27"},
      { text: "PR28", value: "PR28"},
      { text: "PR29", value: "PR29"},
      { text: "PR30", value: "PR30"},
      { text: "PR31", value: "PR31"},

      { text: "KRTJ", value: "KRTJ"},
      { text: "KRTM", value: "KRTM"},
      { text: "PSRJ", value: "PSRJ"},
      { text: "PSRM", value: "PSRM"},
      { text: "PSTJ", value: "PSTJ"},
      { text: "PSTM", value: "PSTM"},
      { text: "JMM", value: "JMM"},
      { text: "JMB", value: "JMB"},
      { text: "PMM", value: "PMM"},
      { text: "PMB", value: "PMB"},
      { text: "KPP", value: "KPP"},
      { text: "PMP", value: "PMP"},
      { text: "BBM", value: "BBM"},
 
    ],
  }),
  methods: {
    async exportexceljre(tokenexport, exportthn,exportbln,exportps,paparnegeriexport){
      try {
        await axios
          .post(
            `${process.env.VUE_APP_API_URL}/sec/checksession`,
            {
                tokenexportsess: window.localStorage.getItem('tokenexport')
            }
          )
          .then(result=>{
            console.log(result.data.status)
            if(result.data.status){
              window.open(`${process.env.VUE_APP_API_URL}/JRE/exportjreserverside/${tokenexport}/${exportthn}/${exportbln}/${exportps}/${paparnegeriexport}/`, '_blank');
            }
          })
      } catch (error) {
        console.log(error)
      }
    }
  },
};
</script>